import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.stock || initialState;

export const selectStock = createSelector(
  [selectSlice],
  state => state.data.items,
);
export const selectStockResponse = createSelector(
  [selectSlice],
  state => state,
);
